export default __webpack_public_path__ + "static/media/panel-about-bkg.fea65265.jpg";